import { all, takeLatest } from 'redux-saga/effects';

import * as actionTypes from '../actionTypes';

import { getBigScreenSaga } from './getBigScreenSaga';

export default function* watchBigScreen() {
    yield all([takeLatest(actionTypes.GET_BIG_SCREEN_DEEP_LINK_REQUEST, getBigScreenSaga)]);
}
